<template>
  <div id="app">
    <div
      :class="{ 'is-mobile': isMobile, obscure: spallaState }"
      v-if="this.dataLoaded"
    >
      <my-header></my-header>
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import MyHeader from "./components/MyHeader.vue";
import path from "path";
import { isUndefined } from "util";

export default {
  name: "App",
  components: {
    MyHeader,
  },
  computed: {
    langDefault() {
      return this.$store.getters.langDefault;
    },
    spallaState() {
      return this.$store.state.obscure;
    },
    proj() {
      return  this.$route.params.proj;
    },
  },
  data: () => {
    return {
      dataLoaded: false,
      isMobile: null,
    };
  },
  methods: {
    checkIfMobile() {
      if (window.innerWidth < 1024) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
    fetchData() {
      if (isUndefined(this.proj)) {
        // eslint-disable-next-line no-console
        console.log("object :>> ", this.proj);
      } else {
        // eslint-disable-next-line no-console
        console.log("object :>> ", this.proj);
        fetch(path.join(__dirname, this.proj + ".json"))
          .then((response) => {
            return response.json();
          })
          .then((json) => {
            this.$store.commit("SET_DATA", json);
            this.dataLoaded = true;
            // Add Dynamic Routing
            this.$router.addRoute({
              path: "/" + this.proj + "/",
              redirect: this.langDefault,
            });
          })
          .catch(function (error) {
            // eslint-disable-next-line no-console
            console.log ("Request failed", error)
          });
      }
    },
  },
  mounted() {
    //console.log('store ', this.$route)
    this.$store.commit("SET_LASTPAGE", this.$route.name);
    this.$store.commit("SET_LANG", this.$route.params.lang);
    this.$store.commit("SET_PROJ", this.$route.params.proj);

    this.checkIfMobile();
    this.fetchData();
    //this.$router.push('/')
  },
  beforeMount() {
		/*
		console.log('this.projDefault :>> ', this.projDefault);
    let username = prompt("Please enter username");
    let password = prompt("Please enter password");
    if (this.proj == "sparr") {
      if (password == "Sparr" && username == "Golder") {
        console.log("ok :>> ", "sparr");
      } else {
        window.location.href = "/sparr/en";
      }
    } else if (this.proj == "dwdv") {
			if (password == "Dwdv" && username == "WSP") {
				console.log('username :>> ', username)
      } else {
        window.location.href = "/dwdv/en";
      }
    }*/
  },
};
</script>

<style>
html,
body,
#app {
  padding: 0;
  margin: 0;
  height: 100%;
  width: 100%;
  position: relative;
}

/*.obscure::before {
	content: '';
	background: rgba(0, 0, 0, .5);
	width: 100vw;
	height: calc(110vh +  84px);
	position: absolute;
	top: 0;
	left: 0;
	pointer-events: none;
	z-index: 10;
}*/

@import "https://js.arcgis.com/4.19/esri/themes/light/main.css";


div.esri-search{
  width: 400px;
}


</style>
